export default {
  methods: {
    /**
     * Get taxGroups with precedence: supplierProduct > warehouseProduct > product
     */
    getProductTaxGroups(product) {
      if (product.supplierProduct?.taxGroups?.length) {
        return product.supplierProduct.taxGroups;
      }
      if (product.warehouseProduct?.taxGroups?.length) {
        return product.warehouseProduct.taxGroups;
      }
      return product.taxGroups || [];
    },

    /**
     * Extract tax labels from taxGroups array
     */
    extractTaxLabelsFromTaxGroups(taxGroups) {
      const labels = [];
      for (const taxGroup of taxGroups || []) {
        if (taxGroup.taxes?.length) {
          for (const tax of taxGroup.taxes) {
            const label = tax.label || tax.name;
            if (label && !labels.includes(label)) {
              labels.push(label);
            }
          }
        } else if (taxGroup.name && !labels.includes(taxGroup.name)) {
          labels.push(taxGroup.name);
        }
      }
      return labels;
    },

    /**
     * Get tax labels for order item tables (uses itemsByProduct lookup)
     * @param {Object} row - Product row
     * @param {Object} itemsByProduct - Map of product ID to order item
     */
    getOrderItemTaxLabels(row, itemsByProduct) {
      const item = itemsByProduct?.[row.id];
      if (item?.pricing?.taxes?.taxes?.length) {
        return item.pricing.taxes.taxes.map((tax) => tax.label || tax.name);
      }
      const taxGroups = this.getProductTaxGroups(row);
      return this.extractTaxLabelsFromTaxGroups(taxGroups);
    },

    /**
     * Get tax labels for invoice item tables (uses row.pricing or row.taxes directly)
     */
    getInvoiceItemTaxLabels(row) {
      // Try row.pricing.taxes.taxes first (standard invoice item format)
      if (row?.pricing?.taxes?.taxes?.length) {
        return row.pricing.taxes.taxes.map((tax) => tax.label || tax.name);
      }
      // Fallback to row.taxes.taxes (invoicing items state format)
      if (row?.taxes?.taxes?.length) {
        return row.taxes.taxes.map((tax) => tax.label || tax.name).filter(Boolean);
      }
      return [];
    },
  },
};
